<template>
  <a-card>
    <template slot="title">
      <div style="display: flex;justify-content: space-between">
        <div>{{ $t('settlementInfoEdit') }}</div>
        <div @click="$router.go(-1)"><dol-button><a-icon type="close" /></dol-button></div>
      </div>
    </template>
    <dol-form-model :model="editForm" :rules="validateRules" ref="editForm">
      <dol-row>
        <dol-col style="text-align: center;padding: 0 20px;" :span="12">
          <a-form-model-item class="company-register-form-item" :labelCol="{span: 24}" :wrapperCol="{span: 24}">
            <template slot="label">
              <span>{{ $t('chinaAccount') }}</span>
            </template>
            <a-input v-model.trim="editForm.ACCT_NO" size="large" :placeholder="$t('pleaseEnterYourBankAccountNumber')" />
          </a-form-model-item>
          <a-form-model-item class="company-register-form-item" :labelCol="{span: 24}" :wrapperCol="{span: 24}">
            <template slot="label">
              <span>{{ $t('americaAccount') }}</span>
            </template>
            <a-input v-model.trim="editForm.ACCT_NO3" size="large" :placeholder="$t('pleaseEnterYourBankAccountNumber')" />
          </a-form-model-item>
          <a-form-model-item class="company-register-form-item" :labelCol="{span: 24}" :wrapperCol="{span: 24}">
            <template slot="label">
              <span>{{ $t('bankName') }}</span>
            </template>
            <a-input v-model.trim="editForm.ACCT_BANK" size="large" :placeholder="$t('pleaseEnterTheBankName')" />
          </a-form-model-item>
          <a-form-model-item class="company-register-form-item" :labelCol="{span: 24}" :wrapperCol="{span: 24}"
                             style="margin-bottom:32px;">
            <template slot="label">
              <span>{{ $t('bankPhone') }}</span>
            </template>
            <a-input v-model.trim="editForm.ACCT_PHONE" size="large" />
          </a-form-model-item>
        </dol-col>
        <dol-col style="padding: 0 20px;" :span="12">
          <a-form-model-item class="company-register-form-item" :labelCol="{span: 24}" :wrapperCol="{span: 24}">
            <template slot="label">
              <span>{{ $t('russiaAccount') }}</span>
            </template>
            <a-input v-model.trim="editForm.ACCT_NO2" size="large" :placeholder="$t('pleaseEnterYourBankAccountNumber')" />
          </a-form-model-item>
          <a-form-model-item class="company-register-form-item" :labelCol="{span: 24}" :wrapperCol="{span: 24}">
            <template slot="label">
              <span>{{ $t('bankCode') }}</span>
            </template>
            <a-input v-model.trim="editForm.SWIFT_CODE" size="large" :placeholder="$t('pleaseEnterTheAccountOpeningCode')" />
          </a-form-model-item>
          <a-form-model-item class="company-register-form-item" :labelCol="{span: 24}" :wrapperCol="{span: 24}">
            <template slot="label">
              <span>{{ $t('bankAddress') }}</span>
            </template>
            <a-input v-model.trim="editForm.ACCT_ADDRESS" size="large" :placeholder="$t('pleaseEnterYourBankAddress')" />
          </a-form-model-item>
        </dol-col>
      </dol-row>
      <div style="text-align: center;margin-top: 24px;">
        <a-button type="primary" style="background: #1F6CBA;width: 150px"  @click="updateBank()"
                  block size="large">{{ $t('save') }}
        </a-button>
      </div>
    </dol-form-model>
  </a-card>
</template>

<script>
export default {
  name: "bankInfoEdit",
  data() {
    return {
      fileTypeList: ['.png', '.jpg', '.jpeg', '.bmp', '.gif', '.webp', '.psd', '.svg', '.tiff'],
      editForm: {},
      paramsData:{},
      imgList:[],
      validateRules: {
      },
    }
  },
  methods: {
    updateBank() {
      let data = {...this.editForm}
      data.COMPANY_ID = this.$store.state?.userInfo?.COMPANY_ID
      this.$h5Api({
        type: '2028',
        data: [data],
        showMessage: false,
      }).then(({data, total}) => {
        this.$router.push('company')
      })
    }
  },
  created() {
    if(this.$route.query.bankInfo){
      let data = JSON.parse(this.$route.query.bankInfo)
      this.editForm.ACCT_NO = data.ACCT_NO;
      this.editForm.ACCT_NO2 = data.ACCT_NO2;
      this.editForm.ACCT_NO3 = data.ACCT_NO3;
      this.editForm.ACCT_BANK = data.ACCT_BANK;
      this.editForm.ACCT_PHONE = data.ACCT_PHONE;
      this.editForm.SWIFT_CODE = data.SWIFT_CODE;
      this.editForm.ACCT_ADDRESS = data.ACCT_ADDRESS;
      this.editForm.FLOW_ID = data.FLOW_ID;
    }
  }
}
</script>

<style scoped>

</style>